import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import APInvoiceDashboard from '../components/APInvoiceDashboard/APInvoiceDashboard';

const APInvoiceDashboardPage: React.FC = () => {
  const navigate = useNavigate();

  const handleInvoiceSelect = (invoiceId: string) => {
    console.log('Selected invoice:', invoiceId);
    // Future: navigate to detail view or open analysis panel
  };

  const handleBackToDomains = () => {
    navigate('/domains');
  };

  return (
    <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#fafafa' }}>
      {/* Simple header with back button */}
      <div style={{ 
        padding: '16px 24px', 
        backgroundColor: 'white', 
        borderBottom: '1px solid #e1dfdd',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }}>
        <Button
          appearance="subtle"
          icon={<ArrowLeftRegular />}
          onClick={handleBackToDomains}
        >
          Back to Workflows
        </Button>
        <div style={{ 
          fontSize: '20px', 
          fontWeight: 600,
          color: '#242424'
        }}>
          AP Exception Console
        </div>
      </div>

      {/* Dashboard content */}
      <APInvoiceDashboard onInvoiceSelect={handleInvoiceSelect} />
    </div>
  );
};

export default APInvoiceDashboardPage;
